import find from 'lodash/find';

export default function getUserById(state, id) {
  return find(state.users.users, user => user.id === Number.parseInt(id));
}
